<template>
  <div class="legacy-portfolio-select">
    <button ref="trigger" type="button" class="legacy-portfolio-trigger" :disabled="unavailable"
      aria-haspopup="dialog" :aria-expanded="open" :aria-label="`Seleccionar cartera: ${selectedLabel}`" @click="show">
      <span class="legacy-portfolio-copy">
        <span class="legacy-portfolio-label">Cartera</span>
        <span class="legacy-portfolio-name" :title="selectedLabel">{{ selectedLabel }}</span>
      </span>
      <span class="material-icons-outlined" aria-hidden="true">expand_more</span>
    </button>
    <LegacyPortfolioOverlay :open="open" @click.self="close" @keydown="onKeydown">
      <section ref="dialog" class="legacy-portfolio-dialog" role="dialog" aria-modal="true" aria-label="Seleccionar cartera" tabindex="-1">
        <header>
          <h2>Seleccionar cartera</h2>
          <button type="button" class="legacy-portfolio-close" aria-label="Cerrar selector de cartera" @click="close">
            <span class="material-icons-outlined" aria-hidden="true">close</span>
          </button>
        </header>
        <div class="legacy-portfolio-options">
          <button v-for="option in options" :key="option.id" type="button" class="legacy-portfolio-option"
            :data-portfolio-id="option.id" :aria-pressed="isSelected(option)" @click="choose(option)">
            <span class="material-icons-outlined" aria-hidden="true">account_balance_wallet</span>
            <span class="legacy-portfolio-option-name">{{ option.label }}</span>
            <span v-if="isSelected(option)" class="material-icons-outlined" aria-hidden="true">check</span>
          </button>
        </div>
      </section>
    </LegacyPortfolioOverlay>
  </div>
</template>

<script>
import LegacyPortfolioOverlay from './LegacyPortfolioOverlay.vue';
export default {
  name: 'LegacyPortfolioSelect',
  components: { LegacyPortfolioOverlay },
  props: {
    value: { type: [String, Number], default: '' },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({ open: false }),
  computed: {
    unavailable() { return this.disabled || !this.options.length; },
    selectedLabel() {
      const selected = this.options.find(this.isSelected);
      return selected ? selected.label : (this.unavailable ? 'No disponible' : 'Seleccionar cartera');
    }
  },
  watch: { unavailable(value) { if (value && this.open) this.close(); } },
  methods: {
    isSelected(option) { return String(option.id) === String(this.value); },
    show() {
      if (this.unavailable) return;
      this.open = true;
      this.$nextTick(() => {
        const dialog = this.$refs.dialog;
        if (dialog) (dialog.querySelector('[aria-pressed=true]') || dialog).focus();
      });
    },
    close() {
      this.open = false;
      this.$nextTick(() => { if (this.$refs.trigger && !this.unavailable) this.$refs.trigger.focus(); });
    },
    choose(option) {
      if (this.unavailable) return;
      if (!this.isSelected(option)) this.$emit('change', String(option.id));
      this.close();
    },
    onKeydown(event) {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(); }
      if (event.key !== 'Tab') return;
      const dialog = this.$refs.dialog;
      const buttons = Array.from(dialog.querySelectorAll('button:not(:disabled)'));
      const first = buttons[0], last = buttons[buttons.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) { event.preventDefault(); first.focus(); }
    }
  }
};
</script>

<style lang="scss" scoped>
.legacy-portfolio-select { width: 100%; height: 100%; min-width: 0; font: inherit; }
.legacy-portfolio-trigger { display: flex; align-items: center; justify-content: space-between; gap: 8px; width: 100%; height: 100%; padding: 0 12px; border: 0; border-radius: 0; background: transparent; color: var(--legacy-list-text); font: inherit; text-align: left; cursor: pointer; }
.legacy-portfolio-trigger:hover:not(:disabled) { background: var(--legacy-list-hover); }
.legacy-portfolio-trigger:disabled { opacity: .55; cursor: not-allowed; }
.legacy-portfolio-copy { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.legacy-portfolio-label { font-size: 10px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; color: var(--legacy-control-muted); }
.legacy-portfolio-name { font-size: 13px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.legacy-portfolio-trigger > .material-icons-outlined { font-size: 20px; flex-shrink: 0; }
button:focus-visible { outline: 2px solid #00aedd; outline-offset: -3px; }
.legacy-portfolio-overlay { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; padding: 24px; background: rgba(0,0,0,.4); }
.legacy-portfolio-dialog { display: flex; flex-direction: column; width: 440px; max-width: 100%; max-height: 80vh; overflow: hidden; border: 1px solid var(--legacy-control-border); border-radius: 8px; background: var(--legacy-control-bg); color: var(--legacy-list-text); box-shadow: 0 12px 36px rgba(0,0,0,.2); outline: none; }
header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 16px 20px; background: var(--legacy-list-heading); color: var(--legacy-list-heading-text); border-bottom: 1px solid var(--legacy-border); }
h2 { margin: 0; font-size: 18px; font-weight: 600; }
.legacy-portfolio-close { display: flex; padding: 4px; border: 0; border-radius: 4px; color: inherit; background: transparent; cursor: pointer; }
.legacy-portfolio-close:hover { background: rgba(255,255,255,.15); }
.legacy-portfolio-options { min-height: 0; overflow-y: auto; padding: 12px; }
.legacy-portfolio-option { display: flex; align-items: center; gap: 12px; width: 100%; min-height: 56px; padding: 12px; border: 1px solid transparent; border-radius: 5px; background: transparent; color: inherit; font: inherit; text-align: left; cursor: pointer; }
.legacy-portfolio-option + .legacy-portfolio-option { margin-top: 4px; }
.legacy-portfolio-option:hover { background: var(--legacy-list-hover); }
.legacy-portfolio-option[aria-pressed=true] { background: var(--legacy-list-sort); border-color: var(--legacy-control-border); }
.legacy-portfolio-option-name { flex: 1; min-width: 0; overflow-wrap: anywhere; }
.legacy-portfolio-option > .material-icons-outlined { flex-shrink: 0; font-size: 20px; }
</style>
